export default {
	'show-all-columns': 'Tüm sütnları göster',
	'total-arrested': 'Toplam Tutuklanma',
	'total-payments': 'Toplam Ödemeler',
	'the-difference': 'Farklar'
}